// Front-end only — no back-end counterpart.

export type MenuManagementResource = 'menus' | 'categories' | 'items' | 'modifiers'

export const MenuManagementResource = {
  MENUS: 'menus',
  CATEGORIES: 'categories',
  ITEMS: 'items',
  MODIFIERS: 'modifiers'
} satisfies Record<string, MenuManagementResource>

export const MenuManagementResourceValues: readonly MenuManagementResource[] =
  Object.values(MenuManagementResource)
